// Authentication and user-related hooks
export { useAuth } from '@/components/AuthProvider';
export { useUserPreferences } from './useUserPreferences';
